<div class="dialog-root">
  <div class="dialog-header">
    <div class="dialog-title">
      {{ translationService.getShareText() }}
      @if (data.productName) {
        <span>- {{ data.productName }}</span>
      }
    </div>

    <div class="dialog-header-actions">
      <button
        mat-icon-button
        type="button"
        (click)="close()"
        aria-label="Close"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  @if (errorMessage) {
    <div class="dialog-error">
      {{ errorMessage }}
    </div>
  }

  <div class="dialog-body">
    <div class="dialog-section">
      <h3 class="section-title">
        {{ translationService.getSharedWithText() }}
      </h3>

      @if (sharesDataSource.data.length === 0) {
        <div class="empty">
          {{ translationService.getNotSharedYetText() }}
        </div>
      }

      @if (sharesDataSource.data.length > 0) {
        <table
          mat-table
          [dataSource]="sharesDataSource"
          class="mat-elevation-z1"
        >
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
              {{ translationService.getCompanyNameText() }}
            </th>
            <td mat-cell *matCellDef="let row">{{ row.toCompanyName }}</td>
          </ng-container>

          <ng-container matColumnDef="overrides">
            <th mat-header-cell *matHeaderCellDef>
              {{ translationService.getOverridesText() }}
            </th>
            <td mat-cell *matCellDef="let row">
              @if (
                !row.overrideProductSupplier && !row.overrideComponentSuppliers
              ) {
                <span>-</span>
              }
              @if (row.overrideProductSupplier) {
                <span>
                  {{ translationService.getProductSupplierText() }}
                </span>
              }
              @if (
                row.overrideProductSupplier && row.overrideComponentSuppliers
              ) {
                <span>,</span>
              }
              @if (row.overrideComponentSuppliers) {
                <span>
                  {{ translationService.getComponentsText() }}
                </span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="remove">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row" class="right">
              <button
                mat-stroked-button
                color="warn"
                type="button"
                (click)="revokeShare(row.toCompanyId)"
              >
                <mat-icon>delete</mat-icon>
                {{ translationService.getRemoveText() }}
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      }
    </div>

    <div class="dialog-section">
      <div class="connections-hint">
        <div class="connections-hint-title">
          {{ translationService.getAvailableConnectionsText() }}
        </div>

        @if (connectedCompanies.length === 0) {
          <div class="empty small">
            {{ translationService.getNoSupplyChainConnectionsFoundText() }}
          </div>
        }

        @if (
          connectedCompanies.length > 0 &&
          getAvailableConnections().length === 0
        ) {
          <div class="empty small">
            {{ translationService.getAllConnectionsAlreadyHaveAccessText() }}
          </div>
        }

        @if (getAvailableConnections().length > 0) {
          <mat-chip-listbox
            [multiple]="false"
            [(ngModel)]="selectedToCompanyId"
          >
            @for (c of getAvailableConnections(); track c.id) {
              <mat-chip-option [value]="c.id">
                {{ c.name }}
              </mat-chip-option>
            }
          </mat-chip-listbox>
        }
      </div>

      <div class="override-note">
        <strong>{{ translationService.getSupplierOverridesText() }}</strong>
        {{ translationService.getSupplierOverridesNoteText() }}
      </div>

      <div class="checkboxes">
        <mat-checkbox
          [(ngModel)]="overrideProductSupplier"
          name="overrideProductSupplier"
        >
          {{ translationService.getOverrideProductSupplierText() }}
        </mat-checkbox>

        <mat-checkbox
          [(ngModel)]="overrideComponentSuppliers"
          name="overrideComponentSuppliers"
        >
          {{ translationService.getOverrideComponentSuppliersText() }}
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div class="dialog-footer">
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="addShare()"
      [disabled]="!selectedToCompanyId"
    >
      <mat-icon>add</mat-icon>
      {{ translationService.getAddText() }}
    </button>
  </div>
</div>
